<template>
  <div class="sick-articles-container">
    <!-- 顶部返回与标题栏 -->
    <div class="page-header">
      <div class="back-button" @click="goBack">
        <van-icon name="arrow-left" size="20" />
      </div>
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>

    <div class="page-content">
      <div class="intro-text">
        {{ introText }}
      </div>
      <!-- 文章列表 -->
      <div class="article-list">
        <van-cell
          v-for="article in articles"
          :key="article.id"
          :title="article.title"
          is-link
          @click="goToArticleDetail(article.id)"
          class="article-item"
        >
          <template #label>
            <span class="article-desc">{{ article.description }}</span>
          </template>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, Icon } from 'vant'

export default {
  name: 'ArticlesSick',
  components: {
    'van-cell': Cell,
    'van-icon': Icon
  },
  data () {
    return {
      // 当前页面标题
      pageTitle: '',
      // 页面简介
      introText: '',
      // 当前显示的文章列表
      articles: [],
      // 三类疾病的模拟文章数据
      sickArticlesMap: {
        diabetes: {
          title: '糖尿病知识',
          intro: '糖尿病是一种以高血糖为特征的慢性代谢性疾病，了解糖尿病有助于更好地预防和管理。',
          list: [
            { id: 'dm_1', title: '什么是糖尿病？', description: '糖尿病是一组以高血糖为特征的代谢性疾病。' },
            { id: 'dm_2', title: '糖尿病的早期症状', description: '口渴、多尿、体重下降等可能是糖尿病的早期信号。' },
            { id: 'dm_3', title: '如何科学预防糖尿病', description: '健康饮食、规律运动、控制体重是预防糖尿病的关键。' },
            { id: 'dm_4', title: '糖尿病患者饮食建议', description: '合理搭配主食、蛋白质和蔬菜，控制总热量摄入。' }
          ]
        },
        hyperlipidemia: {
          title: '高血脂知识',
          intro: '高血脂是指血液中脂质含量过高，是心脑血管疾病的重要危险因素。',
          list: [
            { id: 'hl_1', title: '高血脂的危害', description: '高血脂会增加动脉粥样硬化和心血管疾病风险。' },
            { id: 'hl_2', title: '高血脂的饮食调理', description: '减少油脂摄入，多吃蔬菜水果，有助于控制血脂。' },
            { id: 'hl_3', title: '高血脂的常见症状', description: '多数高血脂患者无明显症状，需定期体检。' },
            { id: 'hl_4', title: '运动对高血脂的影响', description: '规律运动有助于降低血脂水平。' }
          ]
        },
        hypertension: {
          title: '高血压知识',
          intro: '高血压是最常见的慢性病之一，长期高血压会损害心、脑、肾等重要器官。',
          list: [
            { id: 'ht_1', title: '高血压的定义', description: '高血压是指动脉血压持续升高的慢性疾病。' },
            { id: 'ht_2', title: '高血压的危险因素', description: '遗传、肥胖、盐摄入过多等均可导致高血压。' },
            { id: 'ht_3', title: '高血压的预防措施', description: '控制体重、减少盐摄入、坚持锻炼有助于预防高血压。' },
            { id: 'ht_4', title: '高血压患者的生活建议', description: '保持良好心态，按时服药，定期监测血压。' }
          ]
        }
      }
    }
  },
  created () {
    // 获取路由参数，决定显示哪类疾病知识
    // 约定路由参数名为 sickType，可为 diabetes、hyperlipidemia、hypertension
    const sickType = this.$route.params.sickType || 'diabetes'
    const sickData = this.sickArticlesMap[sickType] || this.sickArticlesMap.diabetes
    this.pageTitle = sickData.title
    this.introText = sickData.intro
    this.articles = sickData.list
  },
  methods: {
    // 返回上一页
    goBack () {
      this.$router.back()
    },
    // 跳转到文章详情页
    goToArticleDetail (id) {
      this.$router.push({
        path: '/article/detail',
        query: { id }
      })
    }
  }
}
</script>

<style scoped>
.sick-articles-container {
  padding: 8px;
  min-height: 100vh;
  background-color: #f7f8fa;
}
.page-header {
  position: relative;
  margin-bottom: 24px;
  padding-top: 10px;
  text-align: center;
}
.back-button {
  position: absolute;
  top: 10px;
  left: 0;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #323233;
}
.page-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 12px rgba(100, 101, 102, 0.08);
}
.intro-text {
  margin-bottom: 24px;
  line-height: 1.6;
  font-size: 1.3em;
  font-weight: bold;
  color: #323233;
  text-align: justify;
  padding: 16px;
}
.article-list {
  margin-top: 8px;
  padding: 0 0;
}
.article-item {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  font-size: 1.3em;
}
.article-desc {
  font-size: 1.3em;
  color: #646566;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}
</style>
